import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import { MealTypesReports, MenuOrderTypes, currency_symbol, date_format } from '../../../../server/constants';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import { get } from '../../../../server/actions';
import {
    _addNotificationError, groupBy, isRegularLunchOrderType, showFile, getSchoolGrades, convertTwoDecimalPoint, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, getSessionStartEndDates, getLastMonthStartEndDates
} from '../../../../server/util'
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
var _ = require('lodash');
class DonationPartnerReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedDates:{
                startDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).startOf('month'),
                endDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).endOf('month')
            },
            donationPartnerDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            donationPartnerReport:[],
            donationPartners:[],
            selectedDonationPartner:'',
        }
    }
     onChangeDateRange=(startDate,endDate)=>{  
        let _selectedDate={startDate:startDate,endDate:endDate}
        this.setState({selectedDates:_selectedDate},
            this.getDonationMatchReport(startDate, endDate, false)
        );
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
         let selectedDates = this.state.selectedDates
         this.getDonationPartners();
         this.getDonationMatchReport(selectedDates.startDate, selectedDates.endDate, false)
    }
    getDonationPartners=()=>{  
        this.setState({loading: true});
        get('/mealSchools/' + sessionStorage.getItem('SchoolId') + '/donationPartners?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            this.setState({
                donationPartners: ((data._embedded||{}).donationPartners||[]) ,
                loading: false
            })             
        }).catch(
            (error) => {  
                this.setState({loading: false});              
                console.log('Get Users data response', error)
            }
        );
    }
    getDonationMatchReport=(startDate, endDate, isPdf)=>{
        const {selectedDonationPartner}=this.state;
        if(selectedDonationPartner){
        let _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let dateStart = moment(startDate).startOf('D');
        let dateEnd = moment(endDate).endOf('D');
        this.setState({ loading: true });
        
        get( `/reports/donationMatch/${userInfo.schoolId}?donationPartnerId=${selectedDonationPartner}&isExport=${isPdf}&startDate=${moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`).then(res => {
            if (res.statusCode === 417) {
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            console.log(data)
            if (isPdf) {
                let filename = 'Donation_Partner_Report.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                this.setState({
                    donationPartnerReport: data.resp, loading: false
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
            }
        );
        }
    }
    buildReportFormatForExport=()=>{
        let fData = [];
        let result=[];
        (this.state.donationPartnerReport||[]).map(row => {
            fData.push([
                row.donationPartnerName,
                row.donationDate,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.donationAmount)}`,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.donationMatchAmount)}`,
                `${currency_symbol() + ' ' + (Number(convertTwoDecimalPoint(row.donationAmount))+Number(convertTwoDecimalPoint(row.donationMatchAmount))).toFixed(2)}`
            ]);
        });
        result.push(
            {
                columns: ["Donation Partner Name", "Date", `Donation Amount (${currency_symbol()})`, 
                `Donation Match Amount (${currency_symbol()})`, `Total Amount (${currency_symbol()})`],
                data: fData
            }
        );
        return result;

    }
    render() {
        const {donationPartners, selectedDonationPartner}=this.state;
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="panel panel-p1 panel-primary">

                    <div className="panel-heading text-center">
                        <h3 className="panel-title" style={{ display: 'inline' }}>Donation Match Report</h3>
                            <div style={{ 
                                display: 'inline-block', 
                                backgroundColor: 'transparent',             
                                marginTop: '-7px',
                                float: 'right', 
                                borderRadius: '3px' }}>              
                                <div className="btn-group">
                                                    <button className="btn-link btn-sm dropdown-toggle" type="button" 
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{color:'#fff', fontSize:'13px'}}>
                                                    <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                    <li>
                                                        <a title="Click to Download PDF" style={{cursor:'pointer'}}
                                                        onClick={()=>{this.getDonationMatchReport(this.state.selectedDates.startDate,this.state.selectedDates.endDate,true);}}
                                                        target='_blank'
                                                        ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                    </li>
                                                    <li>
                                                        <TmExportExcel id="dprReport" 
                                                            name={"Donation Match Report"}
                                                            filename={"Donation Match Report"}
                                                            element={<a title="Click to Download Excel"  id="dprReport"
                                                            style={{ 
                                                            display: 'block',  
                                                            padding: '3px 20px',
                                                            clear: 'both',
                                                            fontWeight: '400',
                                                            lineHeight: 1.42857143,
                                                            color: '#333',
                                                            whiteSpace: 'nowrap',
                                                            cursor:'pointer'
                                                            }}
                                                            ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                            dataSet={this.buildReportFormatForExport()}
                                                        />                                                        
                                                    </li>
                                                    
                                                    </ul>
                                                </div>
                                            </div>
                    </div>
                    <div className="panel-body">                        
                        <div className="row">
                            <div className='col-md-12'>
                            <div className="row">
                                <div className='col-md-2'>
                                    <label>Select date range:</label>
                                </div>
                                <div className='col-md-4'>                                                                                                                                       
                                    <DateTimeRangePicker
                                        startDate={this.state.selectedDates.startDate} 
                                        endDate={this.state.selectedDates.endDate}
                                        isReport={false}
                                        applyCallback={(event,picker)=>{
                                            this.onChangeDateRange(picker.startDate, picker.endDate)
                                        }}                                                        
                                        isDateShow={true} 
                                    />
                                </div>
                            
                                <div className="col-md-2">
                                    <label>Donation Partner</label>

                                </div>
                                <div className="col-md-2">
                                    <select className='form-control' value={selectedDonationPartner} onChange={(e)=>{
                                        this.setState({selectedDonationPartner:e.target.value, donationPartnerReport:[]},()=>{
                                            this.getDonationMatchReport(this.state.selectedDates.startDate,this.state.selectedDates.endDate, false);
                                        })
                                    }}>
                                        <option value={''}>Select</option>
                                        {
                                            (donationPartners||[]).map((dp,i)=>{
                                                const id=dp._links.self.href.split('/').pop();
                                                return <option key={i} value={id}>{dp.donationPartnerName}</option>
                                            })
                                        }
                                    </select>

                                </div>
                            </div>
                        </div>
                            <div className="col-md-12" style={{marginTop:'5px'}}>
                                <ReactTable ref={(r) => this.dprTable = r} id={'dprTbl'}
                                    filterable
                                    columns={[
                                        {
                                            Header: "Donation Partner",
                                            id: "donationPartnerName",
                                            style: { textAlign: 'left' },
                                            accessor: 'donationPartnerName',
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.donationPartnerName).toLowerCase().startsWith(filter.value.toLowerCase())
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}>Total:  {tempList.length}</div>
                                            }
                                        },
                                        {
                                            Header: "Date",
                                            id: "donationDate",
                                            accessor: row => {
                                                const _row = row;
                                                return moment(_row.donationDate).format(date_format())
                                                                                               
                                            },
                                            width: 100,
                                            style: { textAlign: 'center' }
                                        },
                                        {
                                            Header: `Amount (${currency_symbol()})`,
                                            id: 'donationAmount',
                                            width: 150,
                                            filterable: false,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row.donationAmount)}
                                                    </div>
                                                );
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}> {currency_symbol() + ' ' + (_.sum(_.map(tempList, d => d.donationAmount))).toFixed(2)}</div>
                                            }
                                        },
                                        {
                                            Header: `Donation Match Amount (${currency_symbol()})`,
                                            id: 'donationMatchAmount',
                                            width: 150,
                                            filterable: false,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row.donationMatchAmount)}
                                                    </div>
                                                );
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}> {currency_symbol() + ' ' + (_.sum(_.map(tempList, d => d.donationMatchAmount))).toFixed(2)}</div>
                                            }
                                        },
                                        {
                                            Header: `Total Amount (${currency_symbol()})`,
                                            id: 'Total',
                                            width: 150,
                                            filterable: false,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {currency_symbol() + ' ' + (Number(convertTwoDecimalPoint(row.donationAmount))+Number(convertTwoDecimalPoint(row.donationMatchAmount))).toFixed(2)}
                                                    </div>
                                                );
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}> {currency_symbol() + ' ' + (_.sum(_.map(tempList, d => Number(d.donationAmount)+ Number(d.donationMatchAmount) ))).toFixed(2)}</div>
                                            }
                                        }
                                    ]}
                                    data={_.orderBy(this.state.donationPartnerReport, [ 'donationPartnerName'], ['asc'])}
                                    defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

export default DonationPartnerReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/donationPartnerReport.js